export const measureText = (
  text: string,
  font: string,
  size: string,
  weight: string,
): number => {
  // Create a temporary canvas
  const tempCanvas = document.createElement("canvas");
  const context = tempCanvas.getContext("2d");
  if (!context) {
    throw new Error("Unable to get canvas 2d context");
  }

  // Set the font styling
  context.font = `${weight} ${size}px ${font}`;

  // Measure the text
  const metrics = context.measureText(text);

  // Removing canvas is not necessary.
  // Canvas element is not a part of live DOM and will be garbage collected.

  return metrics.width;
};
